import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import { postJson } from "../Utils/apiUtils";
import { setCompanyNames } from "../Utils/sessionUtils.js";
import { showToast } from "../Utils/variables";

const EditNameBox = ({ handleClickX }) => {
  const [companyName, setCompanyName] = useState("");
  const [companyNameEn, setCompanyNameEn] = useState("");
  const [nameCount, setNameCount] = useState(0);
  const [nameEnCount, setNameEnCount] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getCompanyInfo = async () => {
      try {
        const response = await postJson(
          "/dashboard/company/getCompanyInfo",
          {},
          navigate
        );

        if (response.code !== 200 || !response.data) {
          return;
        }

        const nextCompanyName = response.data.companyName ?? "";
        const nextCompanyNameEn = response.data.companyNameEn ?? "";

        setCompanyName(nextCompanyName);
        setCompanyNameEn(nextCompanyNameEn);
        setNameCount(nextCompanyName.length);
        setNameEnCount(nextCompanyNameEn.length);
      } catch (error) {
        console.error("기업 정보 가져오기 중 에러: ", error);
      }
    };

    getCompanyInfo();
  }, [navigate]);

  const handleEditName = async () => {
    if (!companyName.trim() || isSubmitting) {
      return;
    }

    try {
      setIsSubmitting(true);
      const body = {
        companyName: companyName.trim(),
        companyNameEn: companyNameEn.trim(),
      };
      const data = await postJson(
        "/dashboard/company/updateCompanyName",
        body,
        navigate
      );

      if (data.code === 200) {
        setCompanyNames({
          companyName: body.companyName,
          companyNameEn: body.companyNameEn,
        });
        handleClickX();
        showToast("기본정보 변경이 완료되었습니다.", "success");
      } else if (data.code === 1002) {
        handleClickX();
      } else if (typeof data.message === "string" && data.message.trim()) {
        showToast(data.message, "error");
      }
    } catch (error) {
      console.error("기업명 변경 중 에러: ", error);
      showToast("기업명 변경 중 오류가 발생했습니다.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box>
      <div className="hrz-wrapper">
        <p className="bold-text" style={{ fontSize: "24px" }}>
          기업명 변경
        </p>
        <div style={{ marginLeft: "auto", cursor: "pointer" }}>
          <IconCrossRound onClick={handleClickX} />
        </div>
      </div>

      <FieldLabel>한글명 *</FieldLabel>
      <InputContainer>
        <input
          type="text"
          placeholder="한글 기업명 입력"
          value={companyName}
          onChange={(event) => {
            const value = event.target.value;
            if (value.length <= 40) {
              setCompanyName(value);
              setNameCount(value.length);
            }
          }}
        />
        <CountText>{nameCount}/40</CountText>
      </InputContainer>

      <FieldLabel style={{ marginTop: "18px" }}>영문명</FieldLabel>
      <InputContainer>
        <input
          type="text"
          placeholder="영문 기업명 입력"
          value={companyNameEn}
          onChange={(event) => {
            const value = event.target.value;
            if (value.length <= 40) {
              setCompanyNameEn(value);
              setNameEnCount(value.length);
            }
          }}
        />
        <CountText>{nameEnCount}/40</CountText>
      </InputContainer>

      <div
        className="blueBtn-base center"
        style={{
          width: "400px",
          height: "56px",
          borderRadius: "10px",
          marginTop: "40px",
          backgroundColor:
            companyName.trim() && !isSubmitting ? "#1167ed" : "#b0b0b0",
          cursor: companyName.trim() && !isSubmitting ? "pointer" : "default",
        }}
        onClick={companyName.trim() && !isSubmitting ? handleEditName : null}
      >
        {isSubmitting ? "변경 중..." : "변경하기"}
      </div>
    </Box>
  );
};

const Box = styled.div`
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

const FieldLabel = styled.p`
  margin-top: 30px;
  font-family: "notoSans-medium";
  color: #222222;
`;

const InputContainer = styled.div`
  width: 384px;
  height: 55px;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #e4e4e4;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  cursor: pointer;
  padding-right: 16px;

  > input {
    flex: 1;
    width: 0;
    font-family: "notoSans-medium";
    font-size: 16px;
    margin-left: 14px;
    border: none;
    z-index: 1;

    &:focus {
      outline: none;
    }
  }
`;

const CountText = styled.div`
  color: #888888;
  margin-left: 12px;
  flex-shrink: 0;
`;

const EditName = ({ handleClickX }) => {
  return <LayoutModal Modal={<EditNameBox handleClickX={handleClickX} />} />;
};

export default EditName;
